import { render, staticRenderFns } from "./ImgRankinE3.vue?vue&type=template&id=8ba8a4e6"
import script from "./ImgRankinE3.vue?vue&type=script&lang=js"
export * from "./ImgRankinE3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports